import "../legacy/application"
import * as Routes from '../routes'

window.Routes = Routes
